import { render, staticRenderFns } from "./FirstCall.vue?vue&type=template&id=dfcacf4a&"
import script from "./FirstCall.vue?vue&type=script&lang=js&"
export * from "./FirstCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports